import "../../../../app/assets/sass/_variables.scss";

import { FC } from "react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import { checkIsActive, WithChildren } from "../../../helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import { useLayout } from "../../core";

type AsideMenuItemProps = {
  to: string;
  title: string;
  icon?: IconDefinition;
  hasBullet?: boolean;
  externalLink?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  "data-test-id"?: string;
};

type AsideMenuItemLinkLinkProps = {
  to: string;
  externalLink?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  "data-test-id"?: string;
};

const AsideMenuItem: FC<AsideMenuItemProps & WithChildren> = ({
  children,
  to,
  title,
  icon,
  hasBullet = false,
  externalLink = false,
  onClick,
  "data-test-id": testId,
}) => {
  const { pathname } = useLocation();
  const isActive = checkIsActive(pathname, to);
  const { config } = useLayout();
  const { aside } = config;

  return (
    <div className="menu-item">
      <AsideMenuItemLink to={to} externalLink={externalLink} onClick={onClick} data-test-id={testId}>
        {hasBullet && (
          <span className="menu-bullet">
            <span className="bullet bullet-dot"></span>
          </span>
        )}
        {icon && aside.menuIcon === "svg" && (
          <span className="menu-icon">
            <FontAwesomeIcon
              icon={icon!}
              size="lg"
              style={{ color: isActive ? "var($cpl-secondary)" : "var($cpl-primary)" }}
            />
          </span>
        )}
        <span className="menu-title">{title}</span>
      </AsideMenuItemLink>
      {children}
    </div>
  );
};

const AsideMenuItemLink: FC<AsideMenuItemLinkLinkProps & WithChildren> = ({
  children,
  to,
  externalLink = false,
  onClick,
  "data-test-id": testId,
}) => {
  const { pathname } = useLocation();
  const isActive = checkIsActive(pathname, to);

  if (externalLink) {
    return (
      <a
        data-test-id={testId}
        className={clsx("menu-link without-sub", { active: isActive })}
        href={to}
        target="_blank"
        rel="noreferrer"
        onClick={onClick}
      >
        {children}
      </a>
    );
  } else {
    return (
      <Link
        data-test-id={testId}
        className={clsx("menu-link without-sub", { active: isActive })}
        to={to}
        onClick={onClick}
      >
        {children}
      </Link>
    );
  }
};

export { AsideMenuItem };
